/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitGetEntityStatsQueriesLog
 */
export interface MonitGetEntityStatsQueriesLog {
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityStatsQueriesLog
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityStatsQueriesLog
     */
    page_size?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityStatsQueriesLog
     */
    process_id?: string;
}

/**
 * Check if a given object implements the MonitGetEntityStatsQueriesLog interface.
 */
export function instanceOfMonitGetEntityStatsQueriesLog(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityStatsQueriesLogFromJSON(json: any): MonitGetEntityStatsQueriesLog {
    return MonitGetEntityStatsQueriesLogFromJSONTyped(json, false);
}

export function MonitGetEntityStatsQueriesLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityStatsQueriesLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
    };
}

export function MonitGetEntityStatsQueriesLogToJSON(value?: MonitGetEntityStatsQueriesLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'process_id': value.process_id,
    };
}

